import { Controller } from 'stimulus'

const CLOSED = 'Closed';
const IN_PROGRESS = 'In progress';

export default class extends Controller {
  static targets = [ 'dateStartedSection', 'dateDoneSection', 'dateDoneField', 'dateStartField', 'pausedTimeSection', 'pausedTimeField' ]

  toggleDateStartedSection(event) {
    if (!this.hasDateStartedSectionTarget) return

    const selectedValue = event.target.value

    const showDateStarted = selectedValue === CLOSED || selectedValue === IN_PROGRESS;
    const showDateDone = selectedValue === CLOSED;

    this.dateStartedSectionTarget.classList.toggle('d-none', !showDateStarted);
    this.dateDoneSectionTarget.classList.toggle('d-none', !showDateDone);
    this.pausedTimeSectionTarget.classList.toggle('d-none', !showDateDone);

    this.setEnabled(this.dateStartFieldTarget, showDateStarted)
    this.setEnabled(this.dateDoneFieldTarget, showDateDone)
    this.setEnabled(this.pausedTimeFieldTarget, showDateDone)
    this.dateDoneFieldTarget.required = showDateDone
  }

  // A field the account's policies make read-only stays disabled.
  setEnabled(field, enabled) {
    field.disabled = !enabled || field.dataset.readonly === 'true'
  }
}
